import { render, staticRenderFns } from "./poinvpaymbypo.vue?vue&type=template&id=e2a18148&scoped=true"
import script from "./poinvpaymbypo.vue?vue&type=script&lang=js"
export * from "./poinvpaymbypo.vue?vue&type=script&lang=js"
import style0 from "./poinvpaymbypo.vue?vue&type=style&index=0&id=e2a18148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a18148",
  null
  
)

export default component.exports